import { GridRequest } from "../core";

export enum ImportedTransactionOutcome {
  Empty = 0,
  Success = 1,
  Failed = 2
}

export enum ImportedTransactionType {
  Sale = 0,
  Refund = 1,
  Void = 2
}

export interface ImportedTransactionFilterDto {
  search?: string;
  startDate?: string;
  endDate?: string;
}

export type ImportedTransactionGridRequestDto = GridRequest<ImportedTransactionFilterDto>;

export interface ImportedTransactionGetDto {
  id: string;
  transactionId: string;
  transactionDate: string;
  transactionType: number;
  transactionAmount: number;
  posSystemId: string;
  sourceSystemName: string;
  locationId: number;
  terminalId: string;
  wasScanned: boolean;
  outcome: number;
  customerName: string;
  customerPhone: string;
  productCount: number;
}

export interface ImportedTransactionSalesPersonDto {
  id: string;
  firstName: string;
  lastName: string;
}

export interface ImportedTransactionProductDto {
  productId: string;
  productName: string;
  manufacturer: string;
  productCategory: string;
  quantity: number;
}

export interface ImportedTransactionDetailDto {
  id: string;
  sessionId: string;
  transactionId: string;
  transactionDate: string;
  transactionType: number;
  transactionAmount: number;
  posSystemId: string;
  sourceSystemName: string;
  locationId: number;
  cashRegisterId: number;
  terminalId: string;
  widgetId: number | null;
  wasScanned: boolean;
  outcome: number;
  customerId: string;
  customerFirstName: string;
  customerLastName: string;
  customerBirthDate: string;
  customerPhone: string;
  customerEmail: string;
  clientProfileId: string;
  salesPerson: ImportedTransactionSalesPersonDto | null;
  products: ImportedTransactionProductDto[];
  payload?: string;
}
